import React, { useContext } from 'react';

import { TranslationStrings } from './getTranslations';

export const TranslationContext = React.createContext<TranslationStrings>({} as TranslationStrings);

interface TranslationProviderProps {
  children: React.ReactNode;
  translations: TranslationStrings;
}

type Interpolation = Record<string, string>;

export const TranslationProvider = ({ children, translations }: TranslationProviderProps) => (
  <TranslationContext.Provider value={translations}>{children}</TranslationContext.Provider>
);

export const useTranslation = () => {
  const translationStrings = useContext(TranslationContext);

  const interpolate = (key: keyof TranslationStrings, interpolation: Interpolation = {}) => {
    return Object.entries(interpolation).reduce(
      (tString, [k, val]) => tString.replace(`%${k}%`, val),
      translationStrings[key],
    );
  };

  return {
    t: (key: keyof TranslationStrings, interpolation: Interpolation = {}) => {
      if (!translationStrings[key]) return key;
      return interpolate(key, interpolation);
    },

    traw: (
      key: keyof TranslationStrings,
      interpolation: Interpolation = {},
      onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void,
    ) => {
      const interpolatedStr = translationStrings[key] ? interpolate(key, interpolation) : key;
      return (
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
        <span
          onClick={onClick}
          dangerouslySetInnerHTML={{
            __html: interpolatedStr,
          }}
        />
      );
    },
  };
};
